import { validateEnvVariable } from './helpers';

const ENV = validateEnvVariable(import.meta.env.VITE_NODE_ENV);

const nodeEnvironment = {
  ENV,
};

export default nodeEnvironment;
